// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=b72cc766-02e6-429e-b1e7-49cf89fd492b";
};